import DeleteConversation from "./components/DeleteConversation/DeleteConversation";

export default DeleteConversation;
